import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SuzukiAppLinkComponent } from './suzuki-app-link/suzuki-app-link.component';

const routes: Routes = [
	{ path: '', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
	{ path: 'suzuki', loadChildren: () => import('./core/core.module').then(m => m.CoreModule) },
	{ path: 'suzuki-mobile-app', component:SuzukiAppLinkComponent },
	//{ path: '**', redirectTo: 'suzuki/page-not-found', pathMatch: 'full' } // Wildcard route for 404
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
